import {
  DiffLine,
  diffWords,
  plainSegments,
} from "@/v2-backoffice-client/components/diff"

export type TranslationFallbackDiffFieldProps = {
  label: string
  code: string
  db: string
}

const CODE_ORIGIN_TITLE =
  "The en-GB fallback currently shipped in this repo's *.text.ts files (mirrored into common.CodeTexts on every merge to master). This is what the sync will overwrite."

const DB_ORIGIN_TITLE =
  "The curated en-GB in the translation database (common.Translations) — the source of truth. The sync workflow commits this text into the repo's *.text.ts fallback."

// One field (Name, Description) of the Pending code sync diff: code text as
// the old side, DB text as the new one, because the sync writes DB -> code.
function TranslationFallbackDiffField(
  props: TranslationFallbackDiffFieldProps,
) {
  const { label, code, db } = props

  if (code === db) {
    return (
      <div className="diff-field">
        <span className="diff-field-label">{label}</span>
        <DiffLine
          side="same"
          origin="both"
          segments={plainSegments(code)}
          empty="(empty)"
        />
      </div>
    )
  }

  const segments = diffWords(code, db)
  return (
    <div className="diff-field">
      <span className="diff-field-label">{label}</span>
      <DiffLine
        side="old"
        origin="code"
        originTitle={CODE_ORIGIN_TITLE}
        segments={segments}
        empty="(no text in code)"
      />
      <DiffLine
        side="new"
        origin="DB"
        originTitle={DB_ORIGIN_TITLE}
        segments={segments}
        empty="(no text in DB)"
      />
    </div>
  )
}

export default TranslationFallbackDiffField
